<ui-panel>
  <ui-panel-body class="payment-detail detail-panel" *ngIf="detail">
    <ui-panel-display-info-row
      *ngFor="let row of detail"
      [data]="row"
    ></ui-panel-display-info-row>
  </ui-panel-body>
</ui-panel>
